module.exports = __webpack_public_path__ + "static/media/09n.a92066b1.svg";